theme_custom.tabs_slide = function () {
  var number = $(".tab-head.active").attr("data-perrow");
  $(".slider_tab").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: number,
    slidetoscroll: 1,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};
theme_custom.footer_accordian = function () {
  $(".footer-block__heading").on("click", function () {
    if ($(window).width() < 750) {
      $(this).closest(".footer-block").toggleClass("active");
    }
  });

  // $(window).on('load resize', function () {
  //   if ($(window).width() < 750) {
  //     $(".footer-block__heading").on("click", function () {
  //       $(this).closest(".footer-block").toggleClass("active");
  //     });
  //   }
  // });
};
theme_custom.image_logo_sliders = function () {
  $(".multiple_image_logo_slider").slick();
};
theme_custom.copy_discount_code = function () {
  $(".discount_code_copy").click(function () {
    var copyText = $(this)
      .closest(".discount_code_main")
      .find(".discount_code")
      .data("code");
    navigator.clipboard.writeText(copyText);
    alert("Coupon has been copied: " + copyText);
  });
};

theme_custom.productMediaSlider = function () {
  $(".product_verical_main .slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    infinite: false,
    asNavFor: ".product_verical_main .slider-nav",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
        },
      },
    ],
  });
  $(".product_verical_main .slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    vertical: true,
    infinite: false,
    asNavFor: ".product_verical_main .slider-for",
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          vertical: false,
        },
      },
      {
        breakpoint: 380,
        settings: {
          vertical: false,
          slidesToShow: 2,
        },
      },
    ],
  });
};

theme_custom.slickSlider = function () {
  $(".pair_product_slider").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slideToScroll: 1,
    infinite: false,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".enable__slider")?.slick();

  var intervalId = window.setInterval(function () {
    var script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
    script.type = "text/javascript";
    document.querySelector("head").appendChild(script);
    if ($("product-recommendations ul li").length > 4) {
      $(".enable_related_slider")?.slick();
      clearInterval(intervalId);
    }
  }, 100);

  setTimeout(function() {
    clearInterval(intervalId);
  }, 10000);

};

theme_custom.review_slider = function () {
  $(".main_review_section").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    slidetoscroll: 1,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};
theme_custom.video_slider = function () {
  $(".slide_video").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 4000,
  });
};

theme_custom.productImageRotate = function () {
  $(document).on("click", ".thumbnail-list__item.slider__slide", function () {
    rotateImageOnce();
  });

  var thumbImgRotate = null;
  function rotateImageOnce() {
    if (thumbImgRotate !== null) {
      clearInterval(thumbImgRotate); // Clear the previous interval
    }

    var findActiveClass = $(
      ".product__media-item.is-active .product__media img"
    );
    thumbImgRotate = setInterval(function () {
      findActiveClass.toggleClass("active");
    }, 4000);
  }
  rotateImageOnce();

  thumbImgRotate = window.setInterval(function () {
    var thumbnailActiveLen = $(
      ".product_verical_main .slider.slider-for .slick-current.slick-active img"
    ).length;
    if (thumbnailActiveLen > 0) {
      rotateImageSlickThumbImg();
      var currVarMedId = $(".product_verical_main").attr(
        "data-selected-var-media-id"
      );
      $(
        `.product_verical_main .thumbImg[data-img-id="${currVarMedId}"]`
      )?.click();
      clearInterval(thumbImgRotate);
    }
  }, 1000);

  $(".product_verical_main .slider-nav")
    .on("afterChange", function (event, slick, currentSlide, nextSlide) {
      rotateImageSlickThumbImg();
    })
    .trigger("beforeChange");

  var intervalId = null; // Initialize a variable to hold the interval ID
  function rotateImageSlickThumbImg() {
    var productThumbnailMain = $(
      ".product_verical_main .slider.slider-for .slick-current.slick-active img"
    );

    if (intervalId !== null) {
      clearInterval(intervalId); // Clear the previous interval
    }

    intervalId = setInterval(function () {
      productThumbnailMain.toggleClass("active");
    }, 4000);
  }
};

theme_custom.product_recently_view = function () {
  var product_handle_list = localStorage.getItem("recentlyViewedProducts");
  var url = `/pages/about-us?view=recently-view&products=${product_handle_list}`;
  $.ajax({
    url: url,
    success: function (data) {
      
      getGrid = $(data).find('.recently-view-custom-product-grid').html();
      $('.recently-viewed-grid').html(getGrid);

      // const html = new DOMParser().parseFromString(data, "text/html");
      // var product_html_new = html.querySelector(
      //   ".recently-view-custom-product-grid"
      // );
      // var old_html = document.querySelector(".recently-viewed-grid");
      // old_html.innerHTML = product_html_new.innerHTML;
    },
  });
};

theme_custom.recent_view_slider = function () {
  var desktop_column = $(".recently-viewed-grid").data("desktop-column");
  $(".recent-view-slider")?.slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidetoscroll: 1,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

theme_custom.deliverZipCode = function () {
  var zipCode = document.getElementById("zipcode").value;
  var validZipCodesString =
    document.getElementById("validZipCodes").textContent;
  var validZipCodes = validZipCodesString.split(",").map(function (code) {
    return code.trim();
  });

  if (zipCode.length == 6) {
    $(".Delivery_code .errror_message").hide();
    $(".Delivery_code .success_message").show();
  } else {
    document.getElementById("zipcode").focus();
    $(".Delivery_code .success_message").hide();
    $(".Delivery_code .errror_message").show();
  }

  // if (validZipCodes.includes(zipCode)) {
  //   $(".Delivery_code .errror_message").hide();
  //   $(".Delivery_code .success_message").show();
  // } else {
  //   document.getElementById("zipcode").focus();
  //   $(".Delivery_code .success_message").hide();
  //   $(".Delivery_code .errror_message").show();
  // }
};

theme_custom.shopTheLook = function () {
  $(document).on(
    "click",
    ".shop_the_look_section span.product_dots",
    function () {
      $(this)
        .closest(".shop_look_products")
        .find("span.product_dots")
        .removeClass("active");
      $(this)
        .closest(".shop_look_products")
        .find("ul .dots")
        .removeClass("selected");
      $(this)
        .closest(".shop_look_products")
        .find(".shop_look_product_main .product_details")
        .removeClass("active");
      var select_product = $(this).attr("data");
      $(this).addClass("active");
      $(this)
        .closest(".shop_look_products")
        .find(".product_details")
        .each(function () {
          var get_data = $(this).attr("data");
          if (select_product == get_data) {
            $(this).addClass("active");
          }
        });
      $(this)
        .closest(".shop_look_products")
        .find("ul .dots")
        .each(function () {
          var get_point = $(this).attr("data");
          if (select_product == get_point) {
            $(this).addClass("selected");
          }
        });

      var dataCount = $(this).attr("data-count");
      var dataIndex = $(this)
        .parents(".shop_the_look_section")
        .find(".sticky_mobile_button a")
        .attr("data-index");
      $(this)
        .parents(".shop_the_look_section")
        .find(
          `.product_popup_main .shop_the_look_product__main[data-index="${dataIndex}"]`
        )
        .find(".slick-dots button")
        [dataCount].click();

      // var dataUrl = $(this).attr('data-url');
      // $(this).parents('.shop_the_look_section').find('.sticky_mobile_button a').attr('href', dataUrl);
    }
  );

  $(document).on(
    "click",
    ".shop_the_look_section .product_popup_main .popup_close_btn",
    function () {
      $(this).parents(".product_popup_main").addClass("hidden");
      $("body").removeClass("overflow__hidden");
      $(".shop_the_look_section").removeClass("active");
    }
  );

  $(document).on("click", ".shop_the_look_section ul .dots", function () {
    $(this)
      .closest(".shop_look_products")
      .find("span.product_dots")
      .removeClass("active");
    $(this)
      .closest(".shop_look_products")
      .find("ul .dots")
      .removeClass("selected");
    $(this)
      .closest(".shop_look_products")
      .find(".shop_look_product_main .product_details")
      .removeClass("active");
    var select_product = $(this).attr("data");
    $(this).addClass("selected");
    $(this)
      .closest(".shop_look_products")
      .find(".product_details")
      .each(function () {
        var get_data = $(this).attr("data");
        if (select_product == get_data) {
          $(this).addClass("active");
        }
      });
    $(this)
      .closest(".shop_look_products")
      .find("span.product_dots")
      .each(function () {
        var get_point = $(this).attr("data");
        if (select_product == get_point) {
          $(this).addClass("active");
        }
      });
  });

  // $('.shop_the_look_section .shop_look_slider').on('init', function(event, slick){
  //   var dataUrl = $(this).find('.shop_look_products.slick-current.slick-active .product_dots.active').attr('data-url');
  //   $(this).parents('.shop_the_look_section').find('.sticky_mobile_button a').attr('href', dataUrl);
  // });
  $(".shop_the_look_section .shop_look_slider").slick({
    infinite: false,
    slidesToShow: 1,
    centerMode: false,
    slidesToScroll: 1,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          slidesToShow: 1.1,
        },
      },
    ],
  });
  $(".collection_banner_slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
  });
  $(".shop_the_look_section .shop_the_look__item").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
  });

  $(".shop_the_look_section .shop_the_look__item")
    .on("afterChange", function (event, slick, currentSlide, nextSlide) {
      var target = event.currentTarget;
      var dataSlickIndex = $(target)
        .find(".product_item.slick-current.slick-active")
        .attr("data-slick-index");
      $(target)
        .parents(".shop_the_look_section")
        .find(".shop_look_images .product_dots")
        .removeClass("active");
      $(target)
        .parents(".shop_the_look_section")
        .find(`.shop_look_images .product_dots[data-count="${dataSlickIndex}"]`)
        .addClass("active");
    })
    .trigger("beforeChange");

  $(".shop_the_look_section .shop_look_slider")
    .on("afterChange", function (event, slick, currentSlide, nextSlide) {
      var target = event.currentTarget;
      // var activeUrl = $(target).find('.shop_look_products.slick-current.slick-active .product_dots.active').attr('data-url');
      // $(target).parents('.shop_the_look_section').find('.sticky_mobile_button a').attr('href', activeUrl);
      var mainSliderIndex = $(target)
        .find(".shop_look_products.slick-current.slick-active")
        .attr("data-index");
      $(target)
        .parents(".shop_the_look_section")
        .find(".sticky_mobile_button a")
        .attr("data-index", mainSliderIndex);
    })
    .trigger("beforeChange");

  $(document).on(
    "click",
    ".shop_the_look_section .sticky_mobile_button a",
    function () {
      var btnDataIndex = $(this).attr("data-index");
      parents = $(this).parents(".shop_the_look_section");
      parents
        .find(
          `.product_popup_main .shop_the_look_product__main[data-index="${btnDataIndex}"]`
        )
        .parents(".product_popup_main")
        .removeClass("hidden");
      parents
        .find(
          `.product_popup_main .shop_the_look_product__main[data-index="${btnDataIndex}"]`
        )
        .parents(".product_popup_main")
        .addClass("active");
      parents.addClass("active");
      $("body").addClass("overflow__hidden");

      parents
        .find(".product_popup_main .shop_the_look_product__main")
        .addClass("hidden");
      parents
        .find(
          `.product_popup_main .shop_the_look_product__main[data-index="${btnDataIndex}"]`
        )
        .removeClass("hidden");

      parents
        .find(
          `.product_popup_main .shop_the_look_product__main[data-index="${btnDataIndex}"]`
        )
        .parents(".shop_the_look_section")
        .find(".shop_the_look__item")
        .slick("refresh");

      // var dataCount = parents.find('.shop_look_products.slick-current.slick-active .product_dots.active').attr('data-count');
      // if(dataCount == 1){
      //   setTimeout(function() {
      //     parents.find(`.product_popup_main .shop_the_look_product__main[data-index="${btnDataIndex}"]`).find(`.slick-dots li button`)[1]?.click();
      //   }, 500);
      // }
    }
  );
};

theme_custom.sticky_addToCart = function () {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var height = $(".product_page").height() + 600;
    if (scroll >= height) {
      $(".sticky_addToCart").addClass("active");
    } else {
      $(".sticky_addToCart").removeClass("active");
    }
  });
};
theme_custom.announcebarSticky = function () {
  var annouceTop = 0;
  var findClass = document.querySelectorAll(".sticky_announcement_bar").length;
  if (findClass > 0) {
    annouceTop += document.querySelector(
      ".sticky_announcement_bar"
    ).offsetHeight;
  }
  if (annouceTop > 0) {
    document.querySelectorAll(".shopify-section-header-sticky")[0].style.top =
      annouceTop + "px";
    document.querySelectorAll("#MainContent")[0].style.marginTop =
      annouceTop + "px";
  }
};
theme_custom.size_chart_popup = function () {
  $(".tab-main .heading").on("click", function () {
    var index = $(this).attr("data-index");
    var closest = $(this).closest(".head");
    var closest_content = closest.next();
    closest.find(".heading").removeClass("active");
    closest_content.find("> .content").css("display", "none");
    $(this).addClass("active");

    closest_content.find("> .content").each(function () {
      var dataIndex = $(this).attr("data-index");
      if (dataIndex === index) {
        $(this).css("display", "block");
      }
    });
  });
};

let triggered = false;
function ScrollExecute() {
  let nextUrl = $(".collection-products-load-more-link").attr("href");
  if ($(".collection-hero img").length > 0) {
    collectionHeroHeight = $(".collection-hero").height();
  } else {
    collectionHeroHeight = 1600;
  }
  if (
    $(document).height() - collectionHeroHeight <
      $(document).scrollTop() + $(window).height() + 2000 &&
    triggered == false
  ) {
    triggered = true;
    $.ajax({
      url: nextUrl,
      type: "GET",
      success: function (response) {
        nextUrl = $(response)
          .find(".collection-products-load-more-link")
          .attr("href");
        product_count_custom = $(response).find(".product_count_custom").text();
        if ($(".collection-products-load-more-link").length == 0) {
          return false;
        }
        currentUrl = $(".collection-products-load-more-link").attr("href");
        $(".collection-get-product #product-grid").append(
          $(response).find("#product-grid").html()
        );
        if (
          $(response).find(".collection-products-load-more-main a").length > 0
        ) {
          $(".collection-products-load-more-main a").attr(
            "href",
            $(response)
              .find(".collection-products-load-more-main a")
              .attr("href")
          );
          // $(".collection-products-load-more-main").show();
        } else {
          $(".collection-products-load-more-link").remove();
        }
        triggered = false;
      },
    });
  }
}

$(window).scroll(function () {
  ScrollExecute();
});

theme_custom.hoverImageChange = function () {
  var zoom = $(".slider-for .slick-active .image-hover")
    .find("img")
    .attr("srcset");
  $(".slider-for .slick-active .image-hover").append(
    '<img class="zoom" src="' + zoom + '">'
  );
  $(".slider-for .slick-active .image-hover").mouseenter(function () {
    $(this).mousemove(function (event) {
      var offset = $(this).offset();
      var left = event.pageX - offset.left;
      var top = event.pageY - offset.top;

      $(this).find("img.zoom").addClass("active");
      $(this).find(".zoom.active").css({
        width: "200%",
        left: -left,
        top: -top,
      });
    });
  });

  $(".slider-for .slick-active .image-hover").mouseleave(function () {
    $(this).find("img.zoom").removeClass("active");
    $(this).find(".zoom").css({
      width: "100%",
      left: 0,
      top: 0,
    });
  });
};

setTimeout(function () {
  theme_custom.hoverImageChange();
}, 2000);

$(document).on(
  "click",
  ".product_verical_main .slider.slider-nav .thumbnail-image ",
  function () {
    theme_custom.hoverImageChange();
  }
);

theme_custom.custom_lightbox_slider = function (dataInd) {
  $(".custom_lightbox_slider")?.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    prevArrow:
      '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_4.svg?v=1697615745" /></div>',
    nextArrow:
      '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0839/1255/6839/files/Vector_3.svg?v=1697609845" /></div>',
  });

  $(`.main_product_lightbox .product_images[data-slick-index="${dataInd}"]`).focus();
  setTimeout(function () {
    $(`.main_product_lightbox .product_images[data-slick-index="${dataInd}"]`).focus();
  }, 100);

  $(".custom-model-main").addClass("model-open");
  $("body").addClass("product_light_box_open");
};

document.addEventListener("DOMContentLoaded", function (event) {
  if ($(".main_login_flex").length > 0) {
    setInterval(function () {
      if ($("#customer_login").hasClass("ssi-hidden")) {
        $(".customer.login").addClass("has_form_btn");
      } else {
        $(".customer.login").removeClass("has_form_btn");
      }
    }, 1000);
  }

  // lightbox popup start

  // $(document).on("click", ".image-lightbox img", function () {
    // $(".custom-model-main").addClass("model-open");
    // $("body").addClass("product_light_box_open");
  // });

  $(document).on("click", ".close-btn, .bg-overlay", function () {
    $(".custom-model-main").removeClass("model-open");
    $("body").removeClass("product_light_box_open");
  });

  // Lightbox popup end

  theme_custom.shopTheLook();
  theme_custom.slickSlider();
  theme_custom.review_slider();
  theme_custom.productMediaSlider();
  theme_custom.video_slider();
  theme_custom.image_logo_sliders();
  theme_custom.tabs_slide();

  // var custom_lightbox_slider = window.setInterval(function () {
  //   if ($(".model-open .custom_lightbox_slider").length > 0) {
  //     theme_custom.custom_lightbox_slider();
  //     clearInterval(custom_lightbox_slider);
  //   }
  // }, 500);

  theme_custom.footer_accordian();
  theme_custom.copy_discount_code();
  theme_custom.sticky_addToCart();
  theme_custom.announcebarSticky();
  theme_custom.size_chart_popup();
  $(".Delivery_code button").on("click", function () {
    theme_custom.deliverZipCode();
  });
  var tab_heading = document.querySelectorAll(".tab-head");
  tab_heading.forEach((button) =>
    button.addEventListener("click", function () {
      var index = this.getAttribute("data-index");
      var closest = this.closest(".tab-content-main-wrapper");
      closest.querySelectorAll(".tab-head").forEach(function (item) {
        item.classList.remove("active");
      });
      closest.querySelectorAll(".tab-content").forEach(function (item) {
        item.style.display = "none";
      });
      closest
        .querySelector(`.tab-head[data-index='${index}']`)
        .classList.add("active");
      closest.querySelector(
        `.tab-content[data-index='${index}']`
      ).style.display = "block";
      $(".slider_tab").slick("unslick");
      theme_custom.tabs_slide();
      $(".slider_tab").slick("resize");
    })
  );

  $(document).on("click", ".add_to_cart_hover_main", function () {
    $this = $(this);
    var productHandle = $(this).attr("data-handle");
    var url = `/products/` + productHandle + `?section_id=quick-add`;
    $.ajax({
      url: url,
      success: function (data) {
        var html = $(data);
        var collectionProduct = html.find("#main_id").html();
        $height = $this.parents(".card-wrapper").height();
        $pos_top = $this.parents(".card-wrapper").offset().top + $height - 320;
        $pos_left = $this.parents(".card-wrapper").offset().left;
        $(".add_to_cart_size").css("top", $pos_top);
        $(".add_to_cart_size").css("left", $pos_left);
        $(".add_to_cart_size").html(collectionProduct);
        $("body").addClass("card-overlay");
        $(".add_to_cart_size").addClass("active");
      },
    });
  });

  $(document).on("click", ".add_to_cart_size .close", function () {
    $(".add_to_cart_size").removeClass("active");
    $("body").removeClass("card-overlay");
  });

  $("body").click(function (e) {
    if (!$(e.target).closest(".add_to_cart_size.active").length) {
      $(".add_to_cart_size").removeClass("active");
      $("body").removeClass("card-overlay");
    }
  });

  /* Wishlist size-popup */
  // $(document).on("click", ".wishlist_custom_icon", function () {
  //   $this = $(this);
  //   var productHandle = $(this).attr("data-handle");
  //   var url = `/products/` + productHandle + `?section_id=wishlist-size`;
  //   $.ajax({
  //     url: url,
  //     success: function (data) {
  //       var html = $(data);
  //       var collectionProduct = html.find("#main_wishlist_id").html();
  //       $height = $this.parents(".card-wrapper").height();
  //       $pos_top = $this.parents(".card-wrapper").offset().top + $height - 320;
  //       $pos_left = $this.parents(".card-wrapper").offset().left;
  //       $(".add_to_wishlist").css("top", $pos_top);
  //       $(".add_to_wishlist").css("left", $pos_left);
  //       $(".add_to_wishlist").html(collectionProduct);
  //       $("body").addClass("card-overlay");
  //       $(".add_to_wishlist").addClass("active");
  //     },
  //   });
  // });

  // $(document).on("click", ".add_to_wishlist .close", function () {
  //   $(".add_to_wishlist").removeClass("active");
  //   $("body").removeClass("card-overlay");
  // });

  // $("body").click(function (e) {
  //   if (!$(e.target).closest(".add_to_wishlist.active").length) {
  //     $(".add_to_wishlist").removeClass("active");
  //     $("body").removeClass("card-overlay");
  //   }
  // });

  // $(document).on("click", ".wishlist_add_main label", function () {
  //   $this = $(this);
  //   var currentUrl = location.pathname;
  //   setTimeout(function () {
  //     var wishlistID = $this
  //       .closest(".wishlist_add_main")
  //       .find(".product-variant-id")
  //       .val();
  //     $(".wishlist_add_main")
  //       .find(".wishlist-engine")
  //       .attr("data-variant_id", wishlistID);
  //     window.history.replaceState(null, "", currentUrl);
  //   }, 500);
  // });
  // /* End - Wishlist size-popup */

  $(document).on("click", ".add_to_cart_size label", function () {
    var currentUrl = location.pathname;
    setTimeout(function () {
      window.history.replaceState(null, "", currentUrl);
    }, 500);
  });

  $(document).on("click", ".collection-products-load-more-link", function (e) {
    e.preventDefault();
    var getnextPageLink = $(this).attr("href");
    $.ajax({
      dataType: "html",
      url: getnextPageLink,
      type: "GET",
      success: function (response) {
        $(".collection-get-product #product-grid").append(
          $(response).find("#product-grid").html()
        );
        if (
          $(response).find(".collection-products-load-more-main a").length > 0
        ) {
          $(".collection-products-load-more-main a").attr(
            "href",
            $(response)
              .find(".collection-products-load-more-main a")
              .attr("href")
          );
          $(".collection-products-load-more-main").show();
        } else {
          $(".collection-products-load-more-main").hide();
        }
      },
    });
  });

  var description = $(".Collection_bottom_description");
  var showMoreButton = $(".show-more");
  var showLessButton = $(".show-less");

  $(showMoreButton).click(function () {
    $(description).addClass("addHeight");
    $(this).css("display", "none");
    $(showLessButton).css("display", "inline-block");
  });

  $(showLessButton).click(function () {
    $(description).removeClass("addHeight");
    $(this).css("display", "none");
    $(showMoreButton).css("display", "inline-block");
  });

  //loader hide
  setTimeout(() => {
    $(".main_loder").css("display", "none");
    $("body").removeClass("has-loader");
  }, 500);

  if ($(".recently-viewed-grid ").length > 0) {
    theme_custom.product_recently_view();
  }
  // var recent_view_slider = window.setInterval(function(){
  //   if($(".recent-view-slider li.grid__item").length > 1){
  //     theme_custom.recent_view_slider();
  //     clearInterval(recent_view_slider);
  //   }
  // }, 2000);
  document
    .querySelector("#custom-sizechart-popup")
    ?.addEventListener("click", function () {
      document
        .querySelector(".main-popup-container")
        .classList.add("wrapper-popup-sizechart");
      document.body.classList.add("overlay-main-popup-sizechart");
    });
  document
    .querySelector(".main-popup-container .close-iocn")
    ?.addEventListener("click", function () {
      document
        .querySelector(".main-popup-container")
        .classList.remove("wrapper-popup-sizechart");
      document.body.classList.remove("overlay-main-popup-sizechart");
    });
});

$(document).on("click", ".slider-for .thumbnail-image", function () {
  $(document).find('.custom_lightbox_slider.slick-initialized').slick('unslick');
  dataInd = $(this).attr("data-slick-index");
  setTimeout(function () {
    theme_custom.custom_lightbox_slider(dataInd);
  }, 100);
  
  // $(`.main_product_lightbox .product_images[data-slick-index="${dataInd}"]`).focus();
  // setTimeout(function () {
  //   $(`.main_product_lightbox .product_images[data-slick-index="${dataInd}"]`).focus();
  // }, 500);
});

$(document).on("click", ".toggle-password", function () {
  $(this).toggleClass("active");
  var input = $($(this).attr("toggle"));
  if (input.attr("type") == "password") {
    input.attr("type", "text");
  } else {
    input.attr("type", "password");
  }
});

// Custom popup start
$(document).on("click", ".Click-here", function () {
  $(".main_custom_popup")
    .find(".custom-model-popup-main")
    .removeClass("hidden");
  $(".custom-model-popup-main").addClass("model-open");
});
$(document).on("click", ".close-btn, p.no_thanks", function () {
  $(this)
    .closest(".main_custom_popup")
    .find(".custom-model-popup-main")
    .removeClass("model-open");
  $(this)
    .closest(".main_custom_popup")
    .find(".custom-model-popup-main")
    .addClass("hidden");
  sessionStorage.setItem("popup", "close");
});

var data = sessionStorage.getItem("popup");
if (data == "close") {
  $(".main_custom_popup").find(".custom-model-popup-main").addClass("hidden");
} else {
  // $(".main_custom_popup").find(".custom-model-popup-main").removeClass("hidden");
  // setTimeout(function () {
  //   $(".main_custom_popup").find(".custom-model-popup-main").removeClass("hidden");
  //   $(".custom-model-popup-main").addClass("model-open");
  // }, 7000);  
}
// Custom popup end
